module.exports = __webpack_public_path__ + "img/P3LOGO.435b2a38.png";